<div class="notifications-panel" role="dialog" aria-label="Notifications">
  <header class="panel-header">Notifications</header>
  <div class="panel-body" *ngIf="!loading && notifications.length; else emptyTpl">
    <div
      class="notification-item"
      *ngFor="let n of notifications; trackBy: trackById"
      [class.is-read]="(n.notification_status || '').toUpperCase() === 'READ'"
      [class.is-unread]="isUnread(n)"
      [attr.data-status]="(n.notification_status || '').toLowerCase()"
      (click)="onNotificationClick(n, $event)"
    >
      <div
        class="bullet"
        [class.bullet--read]="(n.notification_status || '').toUpperCase() === 'READ'"
      ></div>
      <div class="notification-content">
        <div class="text-block">
          <div class="title-row">
            <h4 class="title">{{ n.message }}</h4>
          </div>
          <div class="meta">
            <span class="subtitle">{{ n.notification_type_description }}</span>
            <span class="dot" aria-hidden="true">•</span>
            <span class="time">{{ n.time }}</span>
          </div>
        </div>
        <div class="actions" *ngIf="n.message?.includes('request-approval needed.')">
          <button
            type="button"
            class="action-btn action-btn--primary"
            (click)="onReviewStatusChange(n); $event.stopPropagation()"
          >
            Review
          </button>
        </div>
      </div>
    </div>
  </div>
  <ng-template #emptyTpl>
    <div class="panel-body empty">
      <ng-container *ngIf="loading; else noItems">Loading...</ng-container>
      <ng-template #noItems>No notifications</ng-template>
    </div>
  </ng-template>
</div>
